import { onValue, set } from 'firebase/database';
import {
    FETCH_FEATURE_FLAGS,
    FETCH_FEATURE_FLAGS_SUCCESS,
    FETCH_FEATURE_FLAGS_FAILED,
    UPDATE_FEATURE_FLAGS,
} from '../../store/types';
import { firebase } from '../../config/configureFirebase';
import store from '../../store/store';

export const fetchFeatureFlags = () => (dispatch) => {
    try {
        const {
            featureFlagsRef
        } = firebase;

        if (!featureFlagsRef) {
            console.error("Firebase featureFlagsRef is not properly initialized");
            dispatch({
                type: FETCH_FEATURE_FLAGS_FAILED,
                payload: "Firebase reference not initialized"
            });
            return;
        }

        dispatch({
            type: FETCH_FEATURE_FLAGS,
            payload: null
        });

        onValue(featureFlagsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                dispatch({
                    type: FETCH_FEATURE_FLAGS_SUCCESS,
                    payload: data
                });
            } else {
                dispatch({
                    type: FETCH_FEATURE_FLAGS_FAILED,
                    payload: "Unable to fetch database and feature flags settings."
                });
            }
        }, (error) => {
            console.error("Firebase onValue error:", error);
            dispatch({
                type: FETCH_FEATURE_FLAGS_FAILED,
                payload: error.message
            });
        });
    } catch (error) {
        console.error("fetchFeatureFlags error:", error);
        dispatch({
            type: FETCH_FEATURE_FLAGS_FAILED,
            payload: error.message
        });
    }
};

export const updateFeatureFlags = (data, onFailure, onSuccess) => (dispatch) => {
    const {
        featureFlagsRef
    } = firebase;

    if (!featureFlagsRef) {
        if (onFailure) {
            onFailure();
        }

        return;
    }

    dispatch({
        type: UPDATE_FEATURE_FLAGS,
        payload: data
    });

    set(featureFlagsRef, data);
    if (onSuccess) {
        onSuccess();
    }
}; 